import { Cloneable } from 'models/Utils/Cloneable';
import { ItemModel } from 'models/Item/Item';
import { RawItemData } from 'models/Item/types';
import { RawListingSuggestedItemsResponse, RawListingSuggestedItem } from './types';

export class ListingSuggestedItemsModel extends Cloneable {
  listingId: string;
  suggestions: ListingSuggestedItemModel[];

  constructor(raw: RawListingSuggestedItemsResponse) {
    super();
    this.listingId = raw.listing_id;
    this.suggestions = (raw.suggestions || []).map(suggestion => new ListingSuggestedItemModel(suggestion));
  }
}

export class ListingSuggestedItemModel extends Cloneable {
  itemId: string;
  score: number;
  rank: number;
  item: ItemModel;
  rawItem: RawItemData;

  constructor(raw: RawListingSuggestedItem) {
    super();
    this.itemId = raw.item_id;
    this.score = raw.score;
    this.rank = raw.rank;
    this.rawItem = raw.item;
    this.item = new ItemModel(raw.item);
  }
}
